<template>
    <section class="bottom text-center">
        <p class="font-weight-bold mainTitle">誠摯推薦 熱門商品及服務</p>
        <p class="tip">提供全面多樣的保障，保你生活大小事</p>
        <div class="container-xl row mx-auto py-4 py-md-5 mx-auto d-none d-sm-flex justify-content-center">
            <div v-for="(item,index) in recommendLink"
                 :key="index"
                 class="col-12 col-sm-4 pt-4 pb-5 text-center bottomItem"
                 :class="{'mouseover': item.mouseover, 'mouseout': item.mouseout}"
                 @mouseover="setHover('mouseover', item)"
                 @mouseout="setHover('mouseout', item)">
                <img :src="item.iconName"
                     width="95px" />
                <p class="title mt-4 font-weight-bold mb-0">{{item.title}}</p>
                <p class="subtitle mb-3">{{item.subtitle}}</p>
                <a :href="item.link"
                   target="_blank">
                    <button class="btn btnStyle rounded-pill btnStyle-secondary btn-freecontact"
                            :data-ga-element="`${logBlockName}商品及服務_${item.GAData}`">
                        看更多
                    </button>
                </a>
            </div>

        </div>
        <VueSlickCarousel v-bind="settings"
                          class="w-100 mb-5 d-block d-sm-none">

            <div v-for="(item,index) in recommendLink"
                 :key="index"
                 class="pt-4 pb-5 px-2 text-center bottomItem mx-auto">
                <div class="bottomItem-border py-4">
                    <img :src="item.iconName"
                         width="95px"
                         class="mx-auto" />
                    <p class="title mt-4 font-weight-bold mb-0">{{item.title}}</p>
                    <p class="subtitle mb-3">{{item.subtitle}}</p>
                    <a :href="item.link"
                       target="_blank">
                        <button class="btn btnStyle rounded-pill btnStyle-secondary btn-freecontact"
                                :data-ga-element="`${logBlockName}商品及服務_${item.GAData}`">
                            看更多
                        </button>
                    </a>
                </div>
            </div>
        </VueSlickCarousel>
    </section>
</template>
<script type="text/javascript">
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
export default {
    name: 'Bottom',
    components: {
        VueSlickCarousel,
    },
    data() {
        return {
            logBlockName: '新保險網站_',
            settings: {
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 3,
                centerMode: true,
                centerPadding: '20%',
                speed: 500,
                initialSlide: 1,
                responsive: [
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            infinite: false,
                            dots: false,
                            centerMode: true,
                            centerPadding: '11%',
                        }
                    },
                ],
            },
            recommendLink: [
                {
                    iconName: require('@/assets/images/home/bottomMainIcon.png'),
                    title: '主打商品',
                    subtitle: '個人化配置',
                    // 修改官網主打商品連結從設定檔讀取
                    // link: 'https://www.fubon.com/life/planning/guide/?utm_source=web&utm_medium=homepage&utm_campaign=fbagent',
                    link: process.env.VUE_APP_OFFICIAL_MAIN_LINK,
                    GAData: '官網主打商品',
                    mouseover: false,
                    mouseout: false,
                },
                {
                    iconName: require('@/assets/images/home/bottomwebIcon.png'),
                    title: '網路投保',
                    subtitle: '24hr自助',
                    // 修改官網主打商品連結從設定檔讀取
                    // link: 'https://www.fubon.com/life/direct/?utm_source=web&utm_medium=homepage&utm_campaign=fbagent',
                    link: process.env.VUE_APP_OFFICIAL_DIRECT_LINK,
                    GAData: '網路投保',
                    mouseover: false,
                    mouseout: false,
                },
            ],
        };
    },
    methods: {
        setHover(active, item) {
            this.recommendLink.map((item) => {
                item.mouseover = false;
                item.mouseout = false;
            });
            item[active] = true;
        },
    }
};

</script>
<style lang="scss" scoped>
.btnStyle {
    color: #fff;
    background-color: #0089d1;
    border-color: #0089d1;
    border: 0;
    font-size: 1.125rem;
    font-weight: bold;
    padding: 0.75rem 8.5% 0.69rem 8.5%;
    @include media-breakpoint-up(sm) {
        padding: 0.5rem 1.5rem 0.5rem 1.5rem;
        font-size: 0.875rem;
    }
    @include media-breakpoint-up(md) {
        padding: 0.6rem 1.6rem 0.5rem 1.6rem;
        font-size: 1rem;
    }
    @include media-breakpoint-up(lg) {
        padding: 0.75rem 2.1875rem 0.69rem 2.1875rem;
        font-size: 1.125rem;
    }
    &:hover {
        color: #fff;
    }
}
.btnStyle-secondary {
    background-image: linear-gradient(270deg, #01b6d2, #0089d1);
}
.bottom {
    line-height: 1.35;
    padding-top: 25px;
    background-color: #ecf6fc;
    overflow: hidden;
    @include media-breakpoint-up(md) {
        margin-top: -10%;
        background-color: #fff;
        background-size: cover;
        background-position: top center;
        background-image: url("../../assets/images/home/bottomBanner.svg");
        padding-top: 22%;
    }
    @include media-breakpoint-up(lg) {
        margin-top: -6%;
        padding-top: 13%;
    }
    .mainTitle {
        font-size: 22px;
        margin-bottom: 0.5rem;
        @include media-breakpoint-up(sm) {
            font-size: 26px;
        }
        @include media-breakpoint-up(md) {
            font-size: 30px;
        }
    }
    .tip {
        color: #666;
        font-size: 1rem;
        @include media-breakpoint-up(md) {
            font-size: 1.125rem;
        }
    }
    .title {
        color: #333;
        font-size: 1.25rem;
    }
    .subtitle {
        color: #4b4b4b;
        font-size: 0.875rem;
    }
    .bottomItem {
        border: 1px solid transparent;
        width: 30%;
        max-width: 350px;
        cursor: pointer;
        border-radius: 10px;
        &.mouseover {
            border: 1px solid #b6e0f7;
            animation: fadeIn 0.35s linear forwards;
        }
        &.mouseout {
            border: 1px solid transparent;
            animation: fadeOut 0.35s reserve linear forwards;
        }
        @keyframes fadeIn {
            from {
                box-shadow: 0 26px 41px #ecf6fc;
            }
            to {
                box-shadow: 0 26px 41px #b4c5ceb3;
            }
        }
        @keyframes fadeOut {
            from {
                box-shadow: 0 26px 41px #ecf6fc;
            }
            to {
                box-shadow: 0 26px 41px #b4c5ceb3;
            }
        }
    }
    .bottomItem-border {
        border-radius: 10px;
        border: 1px solid #b6e0f7;
        box-shadow: 0 16px 25px #b4c5ceb3;
    }

    .btn {
        padding: 0.563rem;
    }
    .btn-freecontact {
        width: 150px;
        font-size: 1.125rem;
        padding-top: 10px;
        padding-bottom: 8px;
        @include media-breakpoint-up(sm) {
            padding-right: 2.45rem;
            padding-left: 2.45rem;
        }
    }
}
</style>
